import React from 'react';

const EmailLogData = ({ emailLogs }) => (
    <div style={{
        maxHeight: '400px', // Adjust the max height as needed
        overflowY: 'auto', // Enable vertical scroll if necessary
        border: '1px solid #ccc',
        borderRadius: '5px',
        marginBottom: '20px',
        position: 'relative', // Add relative positioning
    }}
    >
        <table style={{
            width: '100%',
            borderCollapse: 'collapse',
        }}
        >
            <thead style={{
                position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 1,
            }}
            >
                <tr style={{ borderBottom: '1px solid #ccc' }}>
                    <th style={cellStyle}>Serial Number</th>
                    <th style={cellStyle}>Alert Type</th>
                    <th style={cellStyle}>Author ID</th>
                    <th style={cellStyle}>Created</th>
                    <th style={cellStyle}>Email Body</th>
                    <th style={cellStyle}>Email Subject</th>
                    <th style={cellStyle}>ID</th>
                    <th style={cellStyle}>Recipient Email</th>
                    <th style={cellStyle}>Recipient ID</th>
                    <th style={cellStyle}>SMTP Reason</th>
                </tr>
            </thead>
            <tbody>
                { emailLogs.map((curr, index) => {
                    const {
                        alert_type,
                        author_id,
                        created,
                        email_body,
                        email_subject,
                        id,
                        recipient_email,
                        recipient_id,
                        smtp_reason,
                    } = curr;

                    return (
                        <tr key={id} style={{ borderBottom: '1px solid #ccc' }}>
                            <td style={cellStyle}>{ index + 1 }</td> { /* Serial number */ }
                            <td style={cellStyle}>{ alert_type }</td>
                            <td style={cellStyle}>{ author_id }</td>
                            <td style={cellStyle}>{ created }</td>
                            <td style={{ ...cellStyle, maxWidth: '200px', overflow: 'auto' }} dangerouslySetInnerHTML={{ __html: email_body }} /> { /* Render email_body as HTML */ }
                            <td style={cellStyle}>{ email_subject }</td>
                            <td style={cellStyle}>{ id }</td>
                            <td style={cellStyle}>{ recipient_email }</td>
                            <td style={cellStyle}>{ recipient_id }</td>
                            <td style={cellStyle}>{ smtp_reason }</td>
                        </tr>
                    );
                }) }
            </tbody>
        </table>
    </div>
);

const cellStyle = {
    padding: '10px',
    textAlign: 'left',
    border: '1px solid #ccc',
    minWidth: '100px', // Adjust minimum width of cells
};

export default EmailLogData;
